import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ml-2 hidden sm:block" }
const _hoisted_2 = { class: "py-1" }
const _hoisted_3 = { class: "flex-1" }

import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue';
import { ArrowCircleDownIcon, ArrowCircleUpIcon, SwitchVerticalIcon } from '@heroicons/vue/solid';
import { SortMenuItem, SortMenuItemDirection } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'UiSortMenu',
  props: {
    modelValue: {
        type: Array<SortMenuItem>,
        default: [],
    },
    label: {
        type: String,
    },
    items: {
        type: Array<SortMenuItem>,
        required: true,
        default: [],
    },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const handleItemClick = (item: SortMenuItem, direction?: SortMenuItemDirection) => {
    const currentItems = [...props.modelValue];
    const currentItem = currentItems.find((cItem) => cItem.key == item.key);

    if (currentItem) {
        if (currentItem.direction === direction) {
            currentItems.splice(currentItems.indexOf(currentItem), 1);
        } else if (direction) {
            currentItem.direction = direction;
        } else {
            currentItem.direction =
                currentItem.direction === SortMenuItemDirection.DESC
                    ? SortMenuItemDirection.ASC
                    : SortMenuItemDirection.DESC;
        }
    } else {
        currentItems.push({ ...item, direction: direction || SortMenuItemDirection.ASC });
    }

    emit('update:modelValue', currentItems);
};

return (_ctx: any,_cache: any) => {
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createBlock(_unref(Menu), {
    as: "div",
    class: "relative"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(MenuButton), { class: "inline-flex rounded bg-white px-3 py-2 text-sm font-medium text-gray-700 shadow ring-1 ring-gray-300 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-opacity-50" }, {
        default: _withCtx(() => [
          _createVNode(_unref(SwitchVerticalIcon), {
            class: "h-5 w-5 text-gray-400",
            "aria-hidden": "true"
          }),
          _createElementVNode("span", _hoisted_1, _toDisplayString(props.label || _ctx.$t('core.actions.Sort')), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(MenuItems), { class: "absolute right-0 z-10 mt-2 w-56 origin-top-right rounded bg-white shadow ring-1 ring-gray-300 focus:outline-none" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
              return (_openBlock(), _createBlock(_unref(MenuItem), { key: index }, {
                default: _withCtx(({ active }) => [
                  _createElementVNode("div", {
                    class: _normalizeClass([
                            active ? 'bg-gray-100 text-gray-800' : 'text-gray-700',
                            'group flex items-center px-4 py-2 text-sm',
                        ]),
                    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
                  }, [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(item.label), 1),
                    _withDirectives(_createVNode(_unref(ArrowCircleDownIcon), {
                      class: _normalizeClass([[
                                props.modelValue.find(
                                    (m) =>
                                        m.key == item.key &&
                                        m.direction == _unref(SortMenuItemDirection).ASC,
                                )
                                    ? 'text-primary hover:text-gray-300'
                                    : 'hover:text-primary text-gray-400',
                            ], "h-6 w-6 cursor-pointer"]),
                      "aria-hidden": "true",
                      onClick: ($event: any) => (handleItemClick(item, _unref(SortMenuItemDirection).ASC))
                    }, null, 8, ["class", "onClick"]), [
                      [_directive_tippy, _ctx.$t('sort.ascending')]
                    ]),
                    _withDirectives(_createVNode(_unref(ArrowCircleUpIcon), {
                      class: _normalizeClass([[
                                props.modelValue.find(
                                    (m) =>
                                        m.key == item.key &&
                                        m.direction == _unref(SortMenuItemDirection).DESC,
                                )
                                    ? 'text-primary hover:text-gray-300'
                                    : 'hover:text-primary text-gray-400',
                            ], "h-6 w-6 cursor-pointer"]),
                      "aria-hidden": "true",
                      onClick: ($event: any) => (handleItemClick(item, _unref(SortMenuItemDirection).DESC))
                    }, null, 8, ["class", "onClick"]), [
                      [_directive_tippy, _ctx.$t('sort.descending')]
                    ])
                  ], 2)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})